import React from 'react'
import Modal from 'react-bootstrap/Modal'
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton'
import ClassEditor from 'components/Store/ClassEditor'
import {useRouteMatch} from 'util/router'


function EditClassModal(props) {

    const {show, onHide, toEdit} = props

    const match = useRouteMatch()

    return(
        <Modal
            centered
            // className={"modal-container custom-map-modal"}
            size="lg"
            // {...props}
            show={show}
            onHide={onHide}
            keyboard={false}
            backdrop={'static'}
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <div className="container">
                    { props.new ? (
                        <ClassEditor 
                        {...props}
                        editClass={toEdit}
                        sendingUrl={match.url}
                        />
                        // <h1>New type of editor</h1>
                    ) : (
                        <div>Something went wrong</div>
                    )}
                    
                </div>
                
        </Modal>
    )
}

function EditClassButton(props) {

    const [open, setOpen] = React.useState(false)
    // React.useState(props.new ? true : false)
    
    const { toEdit } = props
 
    return (
        <div>
            <EditClassModal 
            {...props}
            show={open}
            toEdit={toEdit}
            onHide={() => setOpen(false)}
            new={props.new}
            />
            <IconButton onClick={() => setOpen(true)}>
                <EditIcon/>    
            </IconButton>
            {/* <button onClick={() => setOpen(true)} className="btn btn-link">
                Edit
            </button> */}
        </div>
    );
}

export default EditClassButton